var DialogAnimations;
(function (DialogAnimations) {
  DialogAnimations["FadeIn"] = 'fade-in';
  DialogAnimations["FadeInFromBottom"] = 'fade-in-from-bottom';
  DialogAnimations["FadeInFromLeft"] = 'fade-in-from-left';
  DialogAnimations["FadeInFromRight"] = 'fade-in-from-right';
  DialogAnimations["FadeInFromTop"] = 'fade-in-from-top';
})(DialogAnimations || (DialogAnimations = {}));
var DialogSizes;
(function (DialogSizes) {
  DialogSizes["Auto"] = 'auto';
  DialogSizes["Fullscreen"] = 'fullscreen';
  DialogSizes["Large"] = 'large';
  DialogSizes["Medium"] = 'medium';
  DialogSizes["Small"] = 'small';
  DialogSizes["Unlimited"] = 'unlimited';
  DialogSizes["Xlarge"] = 'xlarge';
  DialogSizes["Xsmall"] = 'xsmall';
  DialogSizes["Xxlarge"] = 'xxlarge';
  DialogSizes["Xxsmall"] = 'xxsmall';
})(DialogSizes || (DialogSizes = {}));
var DialogTypes;
(function (DialogTypes) {
  DialogTypes["Drawer"] = 'drawer';
  DialogTypes["Modal"] = 'modal';
})(DialogTypes || (DialogTypes = {}));
var DrawerAnimations;
(function (DrawerAnimations) {
  DrawerAnimations["FadeInFromLeft"] = 'fade-in-from-left';
  DrawerAnimations["FadeInFromRight"] = 'fade-in-from-right';
})(DrawerAnimations || (DrawerAnimations = {}));
export { DialogAnimations, DialogSizes, DialogTypes, DrawerAnimations };